import { render, staticRenderFns } from "./SeasonDetail.vue?vue&type=template&id=3041bfb2&scoped=true"
import script from "./SeasonDetail.vue?vue&type=script&lang=ts"
export * from "./SeasonDetail.vue?vue&type=script&lang=ts"
import style0 from "./SeasonDetail.vue?vue&type=style&index=0&id=3041bfb2&prod&scoped=true&lang=scss"
import style1 from "./SeasonDetail.vue?vue&type=style&index=1&id=3041bfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041bfb2",
  null
  
)

export default component.exports